import { useCallback, useEffect, useState } from 'react'
import { GetPlayerCoinHistoryBetmoneyResponse } from '../../Api/UserPanel/models'
import { getPlayerCoinHistoryBetmoney } from '../../Api/UserPanel/UserPanel'
import toast from 'react-hot-toast'


export const useGetPlayerCoinHistoryBetmoney = ({ form }: { form: { name: string } }) => {
    const [playerCoinHistory, setPlayerCoinHistory] = useState<GetPlayerCoinHistoryBetmoneyResponse | null>(null)
    const [loading, setLoading] = useState(false)

    const getCoinHistory = useCallback(async () => {
        setLoading(true)
        const response = await getPlayerCoinHistoryBetmoney({ name: form?.name?.trim() })
        console.log(response)
        if (response?.response?.data?.msg && response?.response?.data?.msg?.includes('ERROR')) {
            toast.error(response?.response?.data?.msg)
        }
        setPlayerCoinHistory(response)
        setLoading(false)
    }, [form?.name])

    useEffect(() => {
        if (!form?.name) return;
        getCoinHistory();
    }, [getCoinHistory, form?.name]);

    return {
        playerCoinHistory,
        loading,
        getCoinHistory
    }

}
